export default __webpack_public_path__ + "static/media/divider.346b9b3c.svg";